import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { HeroShowcase } from '../ModernShowcase';
import {
  ServicesSection,
  TechnologiesSection,
  PortfolioSection,
} from '../home/HomeSections';
import ClientsLogoCarousel from '../home/ClientsLogoCarousel';
import PartnersShowcase from '../home/PartnersShowcase';

import fortinet from '../../assets/img/partners/1.png';
import juniper from '../../assets/img/partners/2.png';
import cisco from '../../assets/img/partners/3.png';
import huawei from '../../assets/img/partners/4.png';

import nepalAirlines from '../../assets/img/clients/NEPAL ARILINES.png';
import kmc from '../../assets/img/clients/Kathmandu Model College.png';
import glacier from '../../assets/img/clients/glacier international.png';
import hib from '../../assets/img/clients/Health Insurance Board.png';
import ratoBangla from '../../assets/img/clients/Rato Bangla School.png';
import ncda from '../../assets/img/clients/NCDA.png';
import tilganga from '../../assets/img/clients/Tilganga.png';
import emerald from '../../assets/img/clients/emerald.png';
import kws from '../../assets/img/clients/kathmandu world school.png';
import ghorahi from '../../assets/img/clients/ghorahi.png';
import caan from '../../assets/img/clients/Civil_Aviation_Authority_of_Nepal.png';
import bajra from '../../assets/img/clients/bajra suppliers.png';
import saltTrading from '../../assets/img/clients/salttrading.png';
import mustang from '../../assets/img/clients/mustang.png';
import nilesh from '../../assets/img/clients/nilesh.png';

const partners = [
  {
    name: 'Fortinet',
    logo: fortinet,
    level: '',
    category: 'Cybersecurity',
    description: 'Enterprise-grade security fabric and threat intelligence.',
  },
  {
    name: 'Juniper',
    logo: juniper,
    level: '',
    category: 'Networking',
    description: 'AI-driven networking for high-performance infrastructure.',
  },
  {
    name: 'Cisco',
    logo: cisco,
    category: 'Infrastructure',
    description: 'Scalable connectivity and digital transformation solutions.',
  },
  {
    name: 'Huawei',
    logo: huawei,
    category: 'Enterprise Tech',
    description: 'Next-generation ICT for cloud, AI, and enterprise systems.',
  },
];

const clients = [
  { name: 'Nepal Airlines', logo: nepalAirlines },
  { name: 'Kathmandu Model College', logo: kmc },
  { name: 'Glacier International', logo: glacier },
  { name: 'Health Insurance Board', logo: hib },
  { name: 'Rato Bangla School', logo: ratoBangla },
  { name: 'NCDA', logo: ncda },
  { name: 'Tilganga', logo: tilganga },
  { name: 'Emerald', logo: emerald },
  { name: 'Kathmandu World School', logo: kws },
  { name: 'Ghorahi', logo: ghorahi },
  { name: 'Civil Aviation Authority of Nepal', logo: caan },
  { name: 'Bajra Suppliers', logo: bajra },
  { name: 'Salt Trading', logo: saltTrading },
  { name: 'Mustang', logo: mustang },
  { name: 'Nilesh', logo: nilesh },
];

const Home = () => {
  const [refHero] = useInView({ threshold: 0.1, triggerOnce: true });
  const [refCTA, inViewCTA] = useInView({ threshold: 0.1, triggerOnce: true });

  return (
    <div className="bg-white dark:bg-gray-900 overflow-hidden">
      <section ref={refHero}>
        <HeroShowcase />
      </section>

      <ServicesSection />
      <TechnologiesSection />
      <PortfolioSection />

      <PartnersShowcase partners={partners} />

      <ClientsLogoCarousel clients={clients} />

      {/* Call to Action Section — original design */}
      <section
        ref={refCTA}
        className="py-20 px-6 bg-gradient-to-r from-blue-600 to-purple-600 relative overflow-hidden"
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inViewCTA ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="max-w-5xl mx-auto text-center relative"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Ready to Transform Your Business with Technology?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto">
            Let&apos;s discuss how our solutions can help you achieve your business goals and drive growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-white hover:bg-gray-100 text-blue-600 font-medium rounded-lg transition duration-300 shadow-lg hover:shadow-xl"
            >
              Get Started
            </Link>
            <Link
              to="/services"
              className="px-8 py-4 bg-transparent border-2 border-white text-white font-medium rounded-lg hover:bg-white/10 transition duration-300"
            >
              Explore Services
            </Link>
          </div>
        </motion.div>
      </section>

    </div>
  );
};

export default Home;
